import { TransportOptionSelection } from './../../../../components/transport-options-panel/transport-options-panel.model';
import { TmcContextService } from './../../../../common/tmc-context.service';
import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { TerminalContextConstants } from '@sdbn/tmc-common';

@Component({
    selector: 'app-transport-registration-summary',
    templateUrl: './transport-registration-summary.component.html',
    styleUrls: ['./transport-registration-summary.component.scss'],
    standalone: false
})
export class TransportRegistrationSummaryComponent extends AbstractWidgetComponent implements OnInit {

  gatekeeperMandatory: boolean;
  showSelectedOptions: boolean;
  isUsingSmartphone: boolean;
  numberPlate: string;
  driver: string;
  carrier: string;
  orderReference: string;
  selectedOptions = new Array<string>();
  hintDrivers = new Array<string>();

  constructor(
    private tmcContextService: TmcContextService,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.gatekeeperMandatory = this.dashboardContext.getContextValue(TerminalContextConstants.gatekeeperMandatory);
    this.showSelectedOptions = true;
    this.isUsingSmartphone = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication)
      === TerminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE;
    this.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
    this.driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
    this.carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
    this.orderReference = this.dashboardContext.getContextValue(TerminalContextConstants.orderReference);
    const selectedOptions = this.dashboardContext.getContextValue(TerminalContextConstants.selectedOptions);

    let options = new Array<string>();
    let hints = new Array<string>();

    console.log('selected options are', selectedOptions);

    for (const selectedOption of selectedOptions) {
      const to = this.findTransportOption(selectedOption);
      if (to != null) {
        if (this.translationService.translationExists(to.nameDictionaryKey, this.translationService.language)) {
          options.push(to.nameDictionaryKey);
        }
        if (this.translationService.translationExists(to.hintDriverDictionaryKey, this.translationService.language)) {
          hints.push(to.hintDriverDictionaryKey);
        }
      }
    }

    this.selectedOptions = options;
    this.hintDrivers = hints;

  }

  private findTransportOption(selectedOption: TransportOptionSelection) {
    for (const to of this.tmcContextService.getYardConfiguration().transportOptions) {
      if (to.id === selectedOption.id) {
        return to;
      } else if (to.transportOptions != null)
        for (const childOption of to.transportOptions) {
          if (childOption.id === selectedOption.id) {
            return childOption;
          }
        }
    }
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
